<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BU21Sp/tc-custom/9780062099075.jpg?1731154338364" alt="This image is the cover for the book Agorafabulous!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Agorafabulous!
      </h1>
      <p class="bookDescription body article font2">
        <p>“Sara Benincasa is one of the funniest writers I know—and I know a disturbing number of them. She is also one of the most honest.”<br/>—Sam Apple, author of <i>American Parent</i> and editor-in-chief of <i>The Faster Times </i></p><p>“Sara is extremely funny and should have many books out so we can all read them and laugh.” <br/>—Margaret Cho</p><p>Comedian, writer, blogger, radio and podcast host, and YouTube sensation, Sara Benincasa bravely and outrageously brings us “Dispatches from My Bedroom” with <i>Agorafabulous!</i> One of the funniest and most poignant books ever written about a mental illness, <i>Agorafabulous!</i> is a hilarious, raw, and unforgettable account of how a terrified young woman, literally trapped by her own imagination, evolved into a (relatively) high-functioning professional smartass. Down to earth and seriously funny, Benincasa’s no-holds-barred revelations offer readers the politically incorrect hilarity they heartily crave, yet is so often missing from your typical, weepy, and redemptive personal memoir.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sara Benincasa
      </h2>
      
      <p class="authorDescription body article"><P>Sara Benincasa is a comedian and author of &#160;<I>Real Artists Have Day Jobs </I>(William Morrow 2016) as well as the books&#160;&#160;<I>DC Trip</I> (Adaptive Books 2015), <I>Great</I> (2014), and <I>Agorafabulous!: Dispatches From My Bedroom</I> (William Morrow 2012), a book based on her critically acclaimed solo show about panic attacks and agoraphobia. She is currently adapting <I>DC Trip</I> as a film with producers Albert Berger and Ron Yerxa (<I>Little Miss Sunshine, Nebraska, Election</I>), Van Toffler, and Adaptive Studios. She is currently adapting <I>Agorafabulous!</I> as a TV pilot with executive producers Diablo Cody (<I>Juno, The United States of Tara</I>), and Ben Stiller&#8217;s Red Hour. She was born and raised in New Jersey and graduated from Warren Wilson College and Columbia University Teachers College. She lives in Los Angeles, California.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f34bd7b2